import { ReactNode } from 'react';
import DashboardNav from '@/app/layouts/DashboardNav';
import Footer from '@/shared/components/Footer';

interface Props {
  children: ReactNode;
}

export default function DashboardLayout({ children }: Props) {
  return (
    <div className="min-h-screen min-h-[100dvh] bg-slate-100/80 flex flex-col">
      <DashboardNav />

      <main className="mx-auto max-w-7xl px-0 pt-0 pb-4 sm:px-6 sm:py-8 lg:px-8 flex-1 w-full">
        <div className="rounded-none border border-white/70 bg-white/85 p-3 shadow-2xl shadow-slate-200/60 sm:rounded-3xl sm:p-8">
          {children}
        </div>
      </main>

      <Footer />
    </div>
  );
}
